module.exports = __webpack_public_path__ + "media/images/qr/narrative-qr-mono-6e1d269450fa32f4e9441cd0006d7545.svg";